<template>
  <button
    v-if="mq.isDesktop"
    class="mr-2 flex items-center justify-center rounded-full p-2 hover:bg-gray-100"
    :data-test="'toggle-fullpage'"
    @click="is_expanded = !is_expanded"
  >
    <FontAwesomeIcon
      class="rotate-90 transform"
      :icon="is_expanded ? ['fa', 'down-left-and-up-right-to-center'] : ['fa', 'up-right-and-down-left-from-center']"
    />
  </button>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  is_expanded: {
    type: Boolean,
    default: false,
  },
});

const is_expanded = ref(props.is_expanded);

const emit = defineEmits(['update:expand']);

watch(
  () => props.is_expanded,
  (newValue) => {
    is_expanded.value = newValue;
  },
);

watch(is_expanded, (newValue) => {
  emit('update:expand', newValue);
});
</script>
